import { cva } from 'class-variance-authority'

const baseItem = [
  // Sin bg-transparent: el preflight ya da fondo transparente al <button> y
  // entra en conflicto con bg-primary-95 del estado seleccionado (cn no deduplica).
  // min-w-[260px]: mínimo según spec UX; el ancho real lo define la columna
  // (fit-content del título más largo) y los items estiran a ese ancho.
  'min-w-[260px] h-[42px] px-3 rounded-[4px] flex items-center cursor-pointer select-none transition-colors duration-150 text-primary-10',
  'hover:bg-primary-98',
  'focus:outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-70',
].join(' ')

const baseTrigger = [
  'relative h-full inline-flex items-center justify-center gap-2 px-4 rounded-[4px] cursor-pointer select-none transition-colors duration-150 text-sm font-semibold leading-none tracking-[0.1px] text-primary-10 whitespace-nowrap bg-transparent hover:bg-transparent hover:text-primary-10 active:bg-transparent active:text-primary-10 focus:bg-transparent focus:text-primary-10 focus:outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-70',
].join(' ')

const basePanel = ['bg-tertiary-100 rounded-[4px] shadow-menu-panel px-6 relative z-50 inline-block'].join(' ')

export const menuVariants = {
  trigger: cva(baseTrigger, {
    variants: {
      isOpen: {
        true: 'bg-transparent',
        false: '',
      },
    },
    compoundVariants: [{ isOpen: true, className: 'bg-transparent' }],
    defaultVariants: {
      isOpen: false,
    },
  }),

  panel: cva(basePanel, {
    variants: {},
    compoundVariants: [],
    defaultVariants: {},
  }),

  // Sin ancho fijo: w-max hace que la columna mida lo que su título más largo
  // (mínimo 260px según spec UX) y las cajas (items) estiran a ese ancho.
  column: cva('w-max min-w-[260px] flex flex-col gap-3 py-5 flex-shrink-0', {
    variants: {},
    compoundVariants: [],
    defaultVariants: {},
  }),

  divider: cva('self-stretch py-5 flex-shrink-0', {
    variants: {},
    compoundVariants: [],
    defaultVariants: {},
  }),

  item: cva(baseItem, {
    variants: {
      isSelected: {
        true: 'bg-primary-95',
        false: '',
      },
    },
    compoundVariants: [{ isSelected: true, className: 'bg-primary-95' }],
    defaultVariants: {
      isSelected: false,
    },
  }),

  itemLabel: cva('flex-1 overflow-hidden text-left text-ellipsis whitespace-nowrap', {
    variants: {},
    compoundVariants: [],
    defaultVariants: {},
  }),

  itemChevron: cva('text-primary-10 ml-auto', {
    variants: {},
    compoundVariants: [],
    defaultVariants: {},
  }),

  arrow: cva('absolute h-3 w-6 overflow-hidden pointer-events-none', {
    variants: {},
    compoundVariants: [],
    defaultVariants: {},
  }),

  // gap-8: espaciado de 32px entre botones según spec UX.
  bar: cva('flex bg-primary-98 w-full items-center h-[64px] px-10 lg:px-24 gap-8', {
    variants: {},
    compoundVariants: [],
    defaultVariants: {},
  }),
}
